<template>
  <div>
    <div class="table-wrap">
      <el-table ref="Table" v-if="list" :data="list" :cell-style="cellStayle">
        <el-table-column prop="batch_number" width="180" label="批次号" align="center"></el-table-column>
        <el-table-column prop="project" width="250" label="项目" align="center"></el-table-column>
        <el-table-column prop="name"  label="员工" align="center"></el-table-column>
        <el-table-column prop="job" label="岗位" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0">待提交</el-tag>
            <el-tag v-if="scope.row.status == 1" type="warning">待审批</el-tag>
            <el-tag v-if="scope.row.status == 2" type="danger">拒绝</el-tag>
            <el-tag v-if="scope.row.status == 10" type="success">通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="month" label="奖罚月份" align="center"></el-table-column>
        <el-table-column prop="temperature_money" width="80" label="高温补贴" align="center"></el-table-column>
        <el-table-column prop="festival_money" width="80" label="过节费" align="center"></el-table-column>
        <el-table-column prop="internship_money" width="80" label="顶岗费用" align="center"></el-table-column>
        <el-table-column prop="other_money" width="80" label="其他奖励" align="center"></el-table-column>
        <el-table-column prop="other_subtract_money" width="80" label="其他扣款" align="center"></el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "rewardView",
  data(){
    return{
      loading:false,
      batch_number:'',
      list:[],
    }
  },
  created() {
    this.batch_number = this.$route.query.batch_number;
    this.getList()
  },
  methods:{
    getList(){
      let params = {
        batch_number : this.batch_number,
        page : 1,
        pageSize : 99999,
      }
      Http.get(Http.getPreBaseURL() + '/oa/Reward/getListByBatchNumber', params, res => {
        if (res.code === 0) {
          this.list = res.data.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    cellStayle({row, column, rowIndex, columnIndex}) {
      if (column.label === '高温补贴') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '顶岗费用') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '过节费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '其他奖励') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '其他扣款') {
        if (row.other_subtract_money > 0) {
          return 'background-color : #FFAAAA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #FFAAAA'
        }
      }
    },
  },
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/Attendance/rewardView.vue